import { render, staticRenderFns } from "./Creators.vue?vue&type=template&id=4a65bfd6"
import script from "./Creators.js?vue&type=script&lang=js&external"
export * from "./Creators.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports